import { parseCep, parsePlaca, parseTelefone } from '../../../utils/Parse'

export const formatVeiculos = (veiculos, values) => {
  return veiculos.map((veiculo, index) => ({
    ...veiculo,
    id: values.veiculos[index] ? values.veiculos[index].id : undefined,
    placa: parsePlaca(veiculo.placa),
    proprietario: {
      ...veiculo.proprietario,
      telefone: parseTelefone(veiculo.proprietario.telefone),
      cep: parseCep(veiculo.proprietario.cep),
      id: values.veiculos[index]?.proprietario?.id
    },
    proprietarioDoc: {
      ...veiculo.proprietarioDoc,
      id: values.veiculos[index]?.proprietarioDoc?.id
    },
    crlvImage: values.veiculos[index]
      ? values.veiculos[index].crlvImage
      : undefined
  }))
}
